// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Components
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Card } from "@material-ui/core";

// Components
import Typography from '@material-ui/core/Typography';

interface State {
  stats: any;
}

interface Props {
  pastColor: string;
  data: any;
}

/**
 * @description Home View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class LocationMoneyChart extends React.Component<Props, State> {

  /**
   * Creates an instance of Home.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: Props) {
    super(props);
    this.state = {
      stats: [
        { "name": 'Jav.', "Somme [CHF]": props.data[1] || 0 },
        { "name": 'Fév.', "Somme [CHF]": props.data[2] || 0 },
        { "name": 'Mar.', "Somme [CHF]": props.data[3] || 0 },
        { "name": 'Avr.', "Somme [CHF]": props.data[4] || 0 },
        { "name": 'Mai', "Somme [CHF]": props.data[5] || 0 },
        { "name": 'Juin', "Somme [CHF]": props.data[6] || 0 },
        { "name": 'Juil.', "Somme [CHF]": props.data[7] || 0 },
        { "name": 'Août', "Somme [CHF]": props.data[8] || 0 },
        { "name": 'Sept.', "Somme [CHF]": props.data[9] || 0 },
        { "name": 'Oct.', "Somme [CHF]": props.data[10] || 0 },
        { "name": 'Nov.', "Somme [CHF]": props.data[11] || 0 },
        { "name": 'Déc.', "Somme [CHF]": props.data[12] || 0 }
      ]
    };
  }

  componentWillReceiveProps(props: Props, nextState: State) {
    if (props.data) {
      this.setState({
        stats: [
          { "name": 'Jav.', "Somme [CHF]": props.data[1] || 0 },
          { "name": 'Fév.', "Somme [CHF]": props.data[2] || 0 },
          { "name": 'Mar.', "Somme [CHF]": props.data[3] || 0 },
          { "name": 'Avr.', "Somme [CHF]": props.data[4] || 0 },
          { "name": 'Mai', "Somme [CHF]": props.data[5] || 0 },
          { "name": 'Juin', "Somme [CHF]": props.data[6] || 0 },
          { "name": 'Juil.', "Somme [CHF]": props.data[7] || 0 },
          { "name": 'Août', "Somme [CHF]": props.data[8] || 0 },
          { "name": 'Sept.', "Somme [CHF]": props.data[9] || 0 },
          { "name": 'Oct.', "Somme [CHF]": props.data[10] || 0 },
          { "name": 'Nov.', "Somme [CHF]": props.data[11] || 0 },
          { "name": 'Déc.', "Somme [CHF]": props.data[12] || 0 }]
      });
    }
  }

  /**
   * @description Render the HomeView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {

    const { pastColor } = this.props;

    return (
      <Card>
        <Typography variant="title" style={{ marginLeft: 10, marginTop: 10 }} gutterBottom={true}>Somme des réservations</Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart width={600} height={300} data={this.state.stats}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Somme [CHF]" stroke={pastColor} activeDot={{ r: 10 }} />
          </LineChart>
        </ResponsiveContainer>
      </Card>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Charts/LocationMoneyChart.tsx